// extracted by mini-css-extract-plugin
export default {"innerWrapper":"fs-z","tooltipWrapper":"gs-z","icon":"hs-z","tooltip":"is-z","content":"js-z"};